import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // ✅ useNavigate import kiya
import { FiSearch } from "react-icons/fi";
import { getSentNotificationHistory } from "../../redux/services/NotificationServices/Notification.Services";

function Reminderlist() {
  const navigate = useNavigate(); // ✅ Hook initialize kiya
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");

  const fetchHistory = async () => {
    try {
      setIsLoading(true);
      const res = await getSentNotificationHistory({ per_page: 50, search: search });
      if (res.success) {
        setNotifications(res.data);
      }
    } catch (error) {
      console.log("History API error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [search]);

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Reminder List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Reminder List</span>
          </nav>
        </div>

        <div className="">
          <button
            className="add-btn"
            onClick={() => navigate("/reminder")}
          >
            Send Reminder
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">

            {/* Search */}
            <div className="row mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control custumform"
                  placeholder="Search by Title or Message..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* Table */}
            <div className="st-wrapper-card text-center">
              <div className="st-table-responsive">
                <table className="table st-custom-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Vendor ID</th>
                      <th>Vendor Moblie</th>
                      <th>Vendor Name</th>
                      <th>Title</th>
                      <th>Message</th>
                      <th>Type</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th>Sent At</th>
                    </tr>
                  </thead>

                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="9">Loading...</td>
                      </tr>
                    ) : notifications.length === 0 ? (
                      <tr>
                        <td colSpan="9">No reminders found.</td>
                      </tr>
                    ) : (
                      notifications.map((notif, index) => (
                        <tr key={notif.id}>
                          <td>{index + 1}</td>
                          <td>{notif.vendor_id}</td>
                          <td>{notif.vendor_mobile}</td>
                          <td>{notif.vendor_name}</td>
                          <td>{notif.title}</td>
                          <td style={{ maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {notif.message}
                          </td>
                          <td><span className="badge bg-secondary">{notif.type}</span></td>
                          <td>
                            {notif.priority === 'urgent' ? <span className="badge bg-danger">Urgent</span> :
                              notif.priority === 'high' ? <span className="badge bg-warning text-dark">High</span> :
                                <span className="badge bg-info text-dark">Normal</span>}
                          </td>
                          <td>
                            {notif.is_read ? (
                              <span className="badge bg-success">Read</span>
                            ) : (
                              <span className="badge bg-warning text-dark">Unread</span>
                            )}
                          </td>
                          <td>
                            {new Date(notif.sent_at).toLocaleString('en-GB', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            }).replace(',', '')}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reminderlist;